











































































import EmployeSelect from "../core/Forms/EmployeSelect.vue";
import { InterventionApi } from "../api/InterventionApi";
import WeekSelector from "../core/Forms/WeekSelector.vue";
import { DateUtils } from "../utils/DateUtils";
import TextInput from "../core/Forms/TextInput.vue";
import InputField from "../core/Forms/InputField.vue";
import { UserApi } from "../api/UserApi";
import { User } from "../models/User";
export default {
    name: "PrintRecapitulatifHeures",
    components: { InputField, TextInput, WeekSelector, EmployeSelect },
    data() {
        return {
            selectedEmployes: [],
            startWeek: null,
            endWeek: null,
            monthly: false,
            email: "",
            pdfUrl: "about:blank",
            // Numéro de la dernière demande d'aperçu : les URL signées des
            // demandes précédentes, arrivées en retard, sont ignorées.
            previewRequestId: 0,
            InterventionApi: new InterventionApi(),
            UserApi: new UserApi(),
        };
    },
    computed: {
        // Change dès qu'un critère de l'aperçu change (employés, période,
        // mode mensuel) ; vide quand il n'y a pas d'aperçu à afficher.
        previewKey: function (): string {
            if (
                this.selectedEmployes.length === 0 ||
                this.allEmployes() ||
                !this.startWeek
            ) {
                return "";
            }

            let dateRange = DateUtils.weeksToDateRange(
                this.startWeek,
                this.monthly ? this.endWeek : null
            );

            return [
                _.map(this.selectedEmployes, "id").join(","),
                dateRange.start,
                dateRange.end,
                this.monthly,
            ].join("|");
        },
    },
    watch: {
        previewKey: function () {
            this.loadPreview();
        },
    },
    created() {
        let self = this;
        self.UserApi.getCurrentUser().then(function (user) {
            if (user && user.email) {
                self.email = user.email;
            }
        });
    },
    methods: {
        allEmployes: function (): boolean {
            return (
                this.selectedEmployes.length > 0 &&
                this.selectedEmployes[0].id === 0
            );
        },
        loadPreview: function () {
            let self = this;
            let requestId = ++self.previewRequestId;

            self.pdfUrl = "about:blank";

            if (!self.previewKey) {
                return;
            }

            let dateRange = DateUtils.weeksToDateRange(
                self.startWeek,
                self.monthly ? self.endWeek : null
            );
            self.InterventionApi.getRecapitulatifHeuresPdfSignedUrl(
                _.map(self.selectedEmployes, "id"),
                dateRange.start,
                dateRange.end,
                self.monthly
            )
                .then(function (url) {
                    if (requestId === self.previewRequestId) {
                        self.pdfUrl = url;
                    }
                })
                .catch(function () {
                    if (requestId === self.previewRequestId) {
                        swal(
                            "Le récapitulatif des heures n'a pas pu être chargé",
                            "",
                            "error"
                        );
                    }
                });
        },
        sendByEmail: function () {
            let dateRange = DateUtils.weeksToDateRange(
                this.startWeek,
                this.monthly ? this.endWeek : null
            );
            this.InterventionApi.sendRecapitulatifHeuresPdf(
                this.email,
                dateRange.start,
                dateRange.end,
                this.monthly
            );
            swal(
                "Envoi en cours...",
                "Un email contenant le document demandé va vous être envoyé d'ici quelques minutes.",
                "success"
            );
        },
    },
    destroyed() {
        this.previewRequestId++;
    },
};
